import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Officecleanoutsheader from '../components/Servicelist2/Officecleanoutsheader'
import Officecleanouts from '../components/Servicelist2/Officecleanouts'

const Officecleanoutpage = () => {
  return (
    <div>
        <Navbar/>
        <Officecleanoutsheader/>
        <Officecleanouts/>


        <Footer/>
    </div>
  )
}

export default Officecleanoutpage